// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rpr4","tabsBox":"styles_tabsBox__3E2Q2","createButton":"styles_createButton__I6c-6"};